export default __webpack_public_path__ + "static/media/delta fluted panel.a2e68aae.png";